var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-between gutter-md" }, [
    _c(
      "div",
      { staticClass: "col-12 col-lg-4" },
      [
        _c(
          "select-option",
          {
            attrs: {
              title: _vm.$t("legal_forms.freelancer.title"),
              subtitle: _vm.$t("legal_forms.freelancer.subtitle"),
              active: _vm.isActiveLegalForm("freelancer")
            },
            on: {
              click: function($event) {
                _vm.handleSelectLegalForm("freelancer")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "heroicon-male1 heroicon heroicons-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "100",
                  height: "100",
                  viewBox: "0 0 100 100"
                }
              },
              [
                _c("path", {
                  staticClass:
                    "heroicon-male1-top heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M84.63 83.31c2.96 1.49 5.37 5.37 5.37 8.7V100H10v-8c0-3.31 2.4-7.2 5.37-8.69L40 71v8a10 10 0 1 0 20 0v-8l24.63 12.31z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-male1-collar heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M38 79a12 12 0 0 0 24 0v-4.75l-2-1V79a10 10 0 1 1-20 0v-5.76l-2 1V79z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-male1-hair heroicon-component-fill",
                  attrs: {
                    d:
                      "M31 23c2.06 0 3.98-.9 5.3-2.42l.76-.88 1.15.23c.9.17 1.82.04 2.63-.37l1.1-.57 1 .72a6.96 6.96 0 0 0 8.56-.34l1.01-.85 1.18.6a8.46 8.46 0 0 0 7 .28l1.4-.58.93 1.22a4.99 4.99 0 0 0 6.05 1.52l1.22-.55.97.92A4 4 0 1 0 76 15.55l-.96-.57-.03-1.11a5 5 0 0 0-4.1-4.78l-.93-.17-.46-.83a4 4 0 0 0-4.22-2.02l-1.03.19-.74-.75a8.47 8.47 0 0 0-9.16-1.9l-1.14.45-.92-.8a4.97 4.97 0 0 0-7.12.53l-1.2 1.4-1.5-1.07a6 6 0 0 0-9.3 3.39l-.39 1.55L31.2 9H31a7 7 0 0 0-6.76 5.16l-.23.86-.8.4a4 4 0 1 0 3.58 7.16l.8-.4.83.33A7 7 0 0 0 31 23z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-male1-face heroicon-component-fill",
                  attrs: {
                    d:
                      "M28.09 49A22.02 22.02 0 0 0 42 67.5V79a8 8 0 1 0 16 0V67.5A22.02 22.02 0 0 0 71.91 49h2.1a5 5 0 0 0 0-10H72V24.67a6 6 0 0 1-2.1-1.28 6.97 6.97 0 0 1-8.47-2.14c-2.8 1.13-5.94 1-8.64-.35a8.96 8.96 0 0 1-11.02.43 5.97 5.97 0 0 1-3.96.56 8.98 8.98 0 0 1-9.81 2.6V39h-2a5 5 0 0 0 0 10h2.09z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-male1-mouth heroicon-component-fill",
                  attrs: { d: "M43.07 58a8 8 0 0 0 13.86 0H43.07z" }
                }),
                _c("path", {
                  staticClass: "heroicon-male1-teeth heroicon-component-fill",
                  attrs: {
                    d:
                      "M42.58 57h14.84c.13-.31.24-.65.33-1h-15.5c.09.35.2.69.33 1z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-shadows",
                  attrs: {
                    d:
                      "M40 68.82A23.91 23.91 0 0 0 50 71c3.57 0 6.96-.78 10-2.18V71l8.74 4.37A33.84 33.84 0 0 1 50 81a33.84 33.84 0 0 1-18.74-5.63L40 71v-2.18zM28 24.5c3.5 1.24 7.39.2 9.81-2.6 1.35.27 2.74.07 3.96-.56a8.96 8.96 0 0 0 11.02-.43 10.47 10.47 0 0 0 8.64.35 6.97 6.97 0 0 0 8.47 2.14 6 6 0 0 0 2.1 1.28v2a6 6 0 0 1-2.1-1.28 6.97 6.97 0 0 1-8.47-2.14c-2.8 1.13-5.94 1-8.64-.35a8.96 8.96 0 0 1-11.02.43 5.97 5.97 0 0 1-3.96.56 8.98 8.98 0 0 1-9.81 2.6v-2z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-outline",
                  attrs: {
                    "fill-rule": "nonzero",
                    d:
                      "M19 19a6 6 0 0 1 3.31-5.36A9 9 0 0 1 31.25 7a8 8 0 0 1 12.4-4.51 6.98 6.98 0 0 1 9.97-.75c3.9-1.56 8.36-.64 11.32 2.35a6.03 6.03 0 0 1 6.32 3.02 7 7 0 0 1 5.74 6.7A6 6 0 0 1 74 25v13a6 6 0 1 1-.19 12A24.02 24.02 0 0 1 60 68.83V71l3 1.5 21.63 10.8c2.96 1.5 5.37 5.38 5.37 8.7v8H10v-8c0-3.31 2.4-7.2 5.37-8.7L37 72.52l3-1.5v-2.18A24.02 24.02 0 0 1 26.19 50 6 6 0 0 1 26 38V24.93A6 6 0 0 1 19 19zm23 50.64V79a8 8 0 1 0 16 0v-9.37a23.96 23.96 0 0 1-16 0zm8-.63a22 22 0 0 0 22-22V24.67a6 6 0 0 1-2.1-1.28 6.97 6.97 0 0 1-8.47-2.14c-2.8 1.13-5.94 1-8.64-.35a8.96 8.96 0 0 1-11.02.43 5.97 5.97 0 0 1-3.96.56 8.98 8.98 0 0 1-9.81 2.6V47a22 22 0 0 0 22 22zM36.3 20.58l.76-.88 1.15.23c.9.17 1.82.04 2.63-.37l1.1-.57 1 .72a6.96 6.96 0 0 0 8.56-.34l1.01-.85 1.18.6a8.46 8.46 0 0 0 7 .28l1.4-.58.93 1.22a4.99 4.99 0 0 0 6.05 1.52l1.22-.55.97.92A4 4 0 1 0 76 15.55l-.96-.57-.03-1.11a5 5 0 0 0-4.1-4.78l-.93-.17-.46-.83a4 4 0 0 0-4.22-2.02l-1.03.19-.74-.75a8.47 8.47 0 0 0-9.16-1.9l-1.14.45-.92-.8a4.97 4.97 0 0 0-7.12.53l-1.2 1.4-1.5-1.07a6 6 0 0 0-9.3 3.39l-.39 1.55L31.2 9H31a7 7 0 0 0-6.76 5.16l-.23.86-.8.4a4 4 0 1 0 3.58 7.16l.8-.4.83.33a7 7 0 0 0 7.88-1.94zM26 40a4 4 0 1 0 0 8h.02L26 47v-7zm48 0v8a4 4 0 1 0 0-8zM38 79a12 12 0 0 0 24 0v-4.76l-2-1V79a10 10 0 1 1-20 0v-5.76l-2 1V79zm-1-4.26L16.27 85.1A8.64 8.64 0 0 0 12 92v6h8v-6h1v6h58v-6h1v6h8v-6c0-2.56-1.98-5.75-4.27-6.9L63 74.75V79a13 13 0 0 1-26 0v-4.26zM58.94 55c-.5 4.56-4.36 8-8.95 7.99a8.99 8.99 0 0 1-8.94-8h17.89zm-15.87 3a8 8 0 0 0 13.86 0H43.07zm-.49-1h14.84c.13-.32.24-.66.33-1h-15.5c.09.34.2.68.33 1zm3.26-8.23l.83-.55a4 4 0 0 0 6.66 0l.83.55a5 5 0 0 1-8.32 0zM59 42a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-18 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm24.26-5.13l-.9.45a6 6 0 0 0-6.54-3.2l-.2-1a7 7 0 0 1 7.64 3.74zM41 33c.47 0 .93.05 1.37.13l-.2.99a6.03 6.03 0 0 0-6.54 3.2l-.9-.45A7 7 0 0 1 41 33z"
                  }
                })
              ]
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 col-lg-4" },
      [
        _c(
          "select-option",
          {
            attrs: {
              title: _vm.$t("legal_forms.partnership.title"),
              subtitle: _vm.$t("legal_forms.partnership.subtitle"),
              active: _vm.isActiveLegalForm("partnership")
            },
            on: {
              click: function($event) {
                _vm.handleSelectLegalForm("partnership")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "heroicon-couple1 heroicon heroicons-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "100",
                  height: "100",
                  viewBox: "0 0 100 100"
                }
              },
              [
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-top heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M55.94 69.03c-.4-3.07-2.63-6.37-5.3-7.71L36 54v4a8 8 0 1 1-16 0v-4L5.37 61.32C2.4 62.79 0 66.68 0 70v25h50-6V81c0-3.31 2.41-7.2 5.37-8.68l6.57-3.29z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-collar heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M18 57.24l2-1V58a8 8 0 1 0 16 0v-1.76l2 1V58a10 10 0 1 1-20 0v-.76z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-face heroicon-component-fill",
                  attrs: {
                    d:
                      "M41 35v3c0 5.02-2.84 9.37-7 11.54V58a6 6 0 0 1-12 0v-8.46c-4.16-2.17-7-6.52-7-11.53V35h-2a3 3 0 1 1 0-6h2v-7.34a5.99 5.99 0 0 0 6.42-1.6 5.48 5.48 0 0 0 6.28-.09 7.47 7.47 0 0 0 6.66.46A5 5 0 0 0 41 21v8h2a3 3 0 1 1 0 6h-2z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-mouth heroicon-component-fill",
                  attrs: { d: "M24 44a5 5 0 0 0 8 0h-8z" }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-teeth heroicon-component-fill",
                  attrs: {
                    d:
                      "M23.42 43a4.96 4.96 0 0 1-.32-1h9.8c-.07.35-.18.68-.32 1h-9.16z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-male-hair heroicon-component-fill",
                  attrs: {
                    d:
                      "M41.08 13.92l-.1-.76a2.5 2.5 0 0 0-2.24-2.15l-.64-.06-.21-.6a2 2 0 0 0-2.46-1.27l-.45.13-.4-.26a5.47 5.47 0 0 0-5.55-.37l-.55.28-.5-.37a2.48 2.48 0 0 0-3.54.6l-.51.74-.79-.42a3.5 3.5 0 0 0-4.94 1.93l-.25.7-.75-.03L17 12a4 4 0 0 0-3.94 3.32l-.1.6-.58.18a2 2 0 1 0 1.77 3.54l.5-.35.53.27a3.98 3.98 0 0 0 5.23-1.46l.67-1.1.9.93a3.49 3.49 0 0 0 4.96.08l.6-.6.7.51a5.47 5.47 0 0 0 5.92.4l.82-.46.5.78a3 3 0 0 0 4.57.55l.39-.36.51.11A2.51 2.51 0 0 0 44 16.5a2.5 2.5 0 0 0-2.16-2.48l-.76-.1z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-female-top heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M64.83 64.58l-15.46 7.74C46.4 73.79 44 77.69 44 81v14h56V81c0-3.32-2.4-7.2-5.37-8.68l-14.37-7.19c-.72.4-1.47.74-2.26 1.02v9.84c0 1.44-1.06 4-2.08 5.01L73 83.93 70.08 81A9.08 9.08 0 0 1 68 76v-9.85c-1.12-.4-2.18-.93-3.17-1.57z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-female-collar heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M64 67.24l.5-.25c.5-.02 1-.08 1.5-.17v9.17c0 1.98 1.27 5.03 2.66 6.43L73 86.76l4.34-4.34c1.4-1.4 2.66-4.46 2.66-6.43v-8.75l2 1v7.75c0 2.5-1.48 6.08-3.25 7.84L73 89.6l-5.75-5.76A12.88 12.88 0 0 1 64 76v-8.75z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-female-face heroicon-component-fill",
                  attrs: {
                    d:
                      "M60 51v1a13 13 0 0 0 8 12v12c0 1.44 1.05 3.98 2.08 5L73 83.93 75.92 81A9.11 9.11 0 0 0 78 76V64a13 13 0 0 0 8-12v-1h2a3 3 0 1 0 0-6h-2v-5h-8c-5.4 0-10.32-2.04-14.03-5.38a22.28 22.28 0 0 1-3.97 3.6V45h-2a3 3 0 1 0 0 6h2z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-female-mouth heroicon-component-fill",
                  attrs: {
                    d:
                      "M73 60a3.99 3.99 0 0 1-2.65-1h5.3c-.71.62-1.64 1-2.65 1z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-couple1-female-hair heroicon-component-fill",
                  attrs: {
                    d:
                      "M88 38H78a18.93 18.93 0 0 1-14.23-6.4A19.09 19.09 0 0 1 58 37.15V44c-.73 0-1.41.2-2 .54V36a16 16 0 0 1 32 0v2zm0 14a4 4 0 1 0 0-8v-4a8 8 0 0 1 4.8 14.4l-.8.6v1a9 9 0 0 1-11.1 8.75A14.99 14.99 0 0 0 88 52zm-30 0c0 5.27 2.72 9.9 6.83 12.58L64 65a9 9 0 0 1-7.83-13.44c.55.28 1.17.44 1.83.44z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-shadows",
                  attrs: {
                    d:
                      "M60 46.11v-7.88a22.28 22.28 0 0 0 3.97-3.6A20.93 20.93 0 0 0 78 40h8v7-5h-8c-5.4 0-10.32-2.04-14.03-5.38a22.28 22.28 0 0 1-3.97 3.6v5.9zM15 21.66a5.99 5.99 0 0 0 6.42-1.6 5.48 5.48 0 0 0 6.28-.09 7.47 7.47 0 0 0 6.66.46A5 5 0 0 0 41 21v2a4.98 4.98 0 0 1-6.64-.57 7.48 7.48 0 0 1-6.66-.46 5.48 5.48 0 0 1-6.28.09 5.99 5.99 0 0 1-6.42 1.6v-2zm65.26 43.47A15 15 0 0 0 88 52c.73 0 1.41-.2 2-.53V52c0 5.93-3.03 11.14-7.63 14.19l3.38 1.68A20.92 20.92 0 0 1 72 73a20.92 20.92 0 0 1-13.75-5.13l4.55-2.27A16.97 16.97 0 0 1 56 52v-.53c.59.34 1.27.53 2 .53a15 15 0 0 0 14.5 15c2.64-.1 5.1-.86 7.22-2.14l.54.27zM36 50.69V54l3.35 1.67A20.9 20.9 0 0 1 28 59a20.9 20.9 0 0 1-11.35-3.33L20 54v-3.3a14.93 14.93 0 0 0 8 2.3c2.94 0 5.68-.85 8-2.3z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-outline",
                  attrs: {
                    "fill-rule": "nonzero",
                    d:
                      "M36 7a4 4 0 0 1 3.53 2.12 4.5 4.5 0 0 1 3.28 3.07 4.5 4.5 0 0 1 .19 8.55V28a4 4 0 1 1 0 8v2c0 5.35-2.8 10.04-7 12.7V54l3 1.5 11.63 5.82c2.68 1.34 4.9 4.64 5.3 7.71l4.96-2.48a11 11 0 0 1-6.23-16.36A3.98 3.98 0 0 1 54 48V36a18 18 0 0 1 36 0v2.2A10 10 0 0 1 94 56a11 11 0 0 1-10.08 10.96l10.71 5.36C97.6 73.8 100 77.68 100 81v14H0V70c0-3.32 2.41-7.2 5.37-8.68L17 55.5l3-1.5v-3.3c-4.2-2.66-7-7.35-7-12.7v-2a4 4 0 1 1 0-8v-6a4 4 0 0 1-1.79-7.58 6 6 0 0 1 5.38-4.4 5.5 5.5 0 0 1 6.74-2.71 4.5 4.5 0 0 1 5.34-.76 7.48 7.48 0 0 1 6.67.5c.21-.03.44-.05.66-.05zm52 31v-2a16 16 0 0 0-32 0v8.54a3.98 3.98 0 0 1 2-.54v-6.84a19.1 19.1 0 0 0 5.77-5.57A18.93 18.93 0 0 0 78 38l8 .01h2zM38 22a5 5 0 0 1-3.64-1.57 7.48 7.48 0 0 1-6.66-.46 5.48 5.48 0 0 1-6.28.09 5.99 5.99 0 0 1-6.42 1.6V38a13 13 0 0 0 26 0V21c-.85.64-1.9 1-3 1zm3.08-8.08l-.1-.76a2.5 2.5 0 0 0-2.24-2.15l-.64-.06-.21-.6a2 2 0 0 0-2.46-1.27l-.45.13-.4-.26a5.47 5.47 0 0 0-5.55-.37l-.55.28-.5-.37a2.48 2.48 0 0 0-3.54.6l-.51.74-.79-.42a3.5 3.5 0 0 0-4.94 1.93l-.25.7-.75-.03L17 12a4 4 0 0 0-3.94 3.32l-.1.6-.58.18a2 2 0 1 0 1.77 3.54l.5-.35.53.27a3.98 3.98 0 0 0 5.23-1.46l.67-1.1.9.93a3.49 3.49 0 0 0 4.96.08l.6-.6.7.51a5.47 5.47 0 0 0 5.92.4l.82-.46.5.78a3 3 0 0 0 4.57.55l.39-.36.51.11A2.51 2.51 0 0 0 44 16.5a2.5 2.5 0 0 0-2.16-2.48l-.76-.1zM60 44v8a13 13 0 0 0 26 0V40h-8c-5.4 0-10.32-2.04-14.03-5.38a22.28 22.28 0 0 1-3.97 3.6V44zm28 6a2 2 0 1 0 0-4v4zm0 2c0 5.39-2.84 10.1-7.1 12.75A9.02 9.02 0 0 0 92 56v-1l.8-.6A7.98 7.98 0 0 0 88 40v4a4 4 0 1 1 0 8zm-30-6a2 2 0 1 0 0 4v-4zm0 6c-.66 0-1.28-.16-1.83-.44A9 9 0 0 0 64 65l.83-.42A14.99 14.99 0 0 1 58 52zm6 15.24v8.75c0 2.51 1.48 6.07 3.25 7.84L73 89.6l5.75-5.76A12.9 12.9 0 0 0 82 76v-7.75l-2-1v8.75c0 1.97-1.27 5.04-2.66 6.43L73 86.76l-4.34-4.34A10.95 10.95 0 0 1 66 75.99v-9.17c-.5.09-1 .15-1.5.17l-.5.25zm4 8.75c0 1.45 1.05 4 2.08 5.01L73 83.93 75.92 81A9.11 9.11 0 0 0 78 76v-9.76l-.1-.06a14.98 14.98 0 0 1-9.76.01l-.14.06v9.74zM44 93V81c0-1.3.37-2.69 1-3.98V72h1v3.33a9.53 9.53 0 0 1 3.37-3.01L54 70c0-2.56-1.97-5.75-4.26-6.9L39 57.75V58a11 11 0 0 1-22 0v-.26L6.26 63.1C3.98 64.25 2 67.45 2 70v23h8V72h1v21h33zm2-12v12h6v-7h1v7h38v-7h1v7h6V81a8.64 8.64 0 0 0-4.26-6.9L83 68.75v7.25c0 2.77-1.58 6.6-3.54 8.55L73 91l-6.46-6.46A13.85 13.85 0 0 1 63 75.99v-8.25L50.26 74.1C47.98 75.25 46 78.45 46 81zM13 30a2 2 0 1 0 0 4v-4zm30 4a2 2 0 1 0 0-4v4zM22 51.75V58a6 6 0 0 0 12 0v-6.25a14.96 14.96 0 0 1-12 0zm-4 5.49V58a10 10 0 1 0 20 0v-.76l-2-1V58a8 8 0 1 1-16 0v-1.76l-2 1zm7.17-20.41l.7-.7a3 3 0 0 0 4.25 0l.7.7a3.99 3.99 0 0 1-5.65 0zM23 32a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm.58-4.74l-.31.94a4 4 0 0 0-4.85 2.01l-.9-.45a5 5 0 0 1 6.06-2.5zM34 27a5 5 0 0 1 4.47 2.76l-.9.45a4 4 0 0 0-4.84-2l-.31-.95A5 5 0 0 1 34 27zm0 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-11.92 9a6.05 6.05 0 0 1-.08-1h12a6 6 0 0 1-11.92 1zM24 44a5 5 0 0 0 8 0h-8zm-.58-1h9.16c.14-.32.25-.65.32-1h-9.8c.07.35.18.68.32 1zm47.36 11.33l.56-.83a2.99 2.99 0 0 0 3.32 0l.56.83a3.98 3.98 0 0 1-4.44 0zM68 48a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1-5v1a4 4 0 0 0-3.58 2.21l-.9-.45A5 5 0 0 1 67 43zm12 0a5 5 0 0 1 4.47 2.76l-.9.45A4 4 0 0 0 79 44v-1zm0 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-10.58 9h9.16a5 5 0 0 1-9.16 0zM73 60c1.01 0 1.94-.38 2.65-1h-5.3c.71.62 1.64 1 2.65 1z"
                  }
                })
              ]
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 col-lg-4" },
      [
        _c(
          "select-option",
          {
            attrs: {
              title: _vm.$t("legal_forms.corporation.title"),
              subtitle: _vm.$t("legal_forms.corporation.subtitle"),
              active: _vm.isActiveLegalForm("corporation")
            },
            on: {
              click: function($event) {
                _vm.handleSelectLegalForm("corporation")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "heroicon-landmark heroicon heroicons-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "100",
                  height: "100",
                  viewBox: "0 0 100 100"
                }
              },
              [
                _c("rect", {
                  staticClass:
                    "heroicon-landmark-background heroicon-component-fill",
                  attrs: { width: "96", height: "87", x: "2", y: "12" }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-landmark-peak-outer heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M75.98 19L98 33.1V36H2v-2.9L24.02 19H3v-6h30.4L50 2.37 66.6 13H97v6H75.98z"
                  }
                }),
                _c("polygon", {
                  staticClass:
                    "heroicon-landmark-peak-inner heroicon-component-fill",
                  attrs: { points: "50 8.311 85.452 31 14.548 31" }
                }),
                _c("polygon", {
                  staticClass:
                    "heroicon-landmark-stairs heroicon-component-fill",
                  attrs: {
                    points:
                      "7 87 5 87 5 91 3 91 3 95 1 95 1 99 99 99 99 95 97 95 97 91 95 91 95 87 93 87 93 83 7 83"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-landmark-column-base heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M15 73h10v10H15V73zm20 0h10v10H35V73zm20 0h10v10H55V73zm20 0h10v10H75V73zm0-29h10v5H75v-5zm-20 0h10v5H55v-5zm-20 0h10v5H35v-5zm-20 0h10v5H15v-5z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-landmark-columns heroicon-component-fill",
                  attrs: {
                    d:
                      "M17 48h6v26h-6V48zm20 0h6v26h-6V48zm20 0h6v26h-6V48zm20 0h6v26h-6V48z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-shadows",
                  attrs: {
                    d:
                      "M4 38h92v2H4v-2zm81.45-7h-3.12L50 10.31 17.67 31h-3.12L50 8.31 85.45 31zM20.31 19l-3.12 2H4v-2h16.31zm59.38 0H96v2H82.81l-3.12-2zM15 44h10v6h-2v1h-6v-1h-2v-6zm20 0h10v6h-2v1h-6v-1h-2v-6zm20 0h10v6h-2v1h-6v-1h-2v-6zm20 0h10v6h-2v1h-6v-1h-2v-6z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-outline",
                  attrs: {
                    "fill-rule": "nonzero",
                    d:
                      "M98 38v56h2v6H0v-6h2V38H0v-6l2-1.28V12h29.25L50 0l18.75 12H98v18.72l2 1.28v6h-2zM50 2.37L2 33.1V36h96v-2.9L50 2.36zM96 40v-2H4v2h92zM4 41v1h92v-1H4zm87 3h-4v4h-2v2h-1v22h2v10h5V44zm1 0v38h1V44h-1zm2 38v4h2V44h-2v38zM8 44H7v38h1V44zm1 38h5V72h2V50h-1v-2h-2v-4H9v38zM4 44v42h2V44H4zm14 6v23h2v-8h1v8h1V49h-2v10h-1V49h-1v1zm7 0h-1v22h2v10h8V72h2V50h-1v-2h-2v-4h-6v4h-2v2zm13-1v24h2v-8h1v8h1V49h-2v10h-1V49h-1zm7 0v1h-1v22h2v10h8V72h2V50h-1v-2h-2v-4h-6v4h-2v1zm13 1v23h2v-8h1v8h1V49h-2v10h-1V49h-1v1zm7 0h-1v22h2v10h8V72h2V50h-1v-2h-2v-4h-6v4h-2v2zm13-1v24h2v-8h1v8h1V49h-2v10h-1V49h-1zm5-1v-1h-6v1h6zm1 34v-1h-8v1h8zm-8-2h8v-6h-8v6zm1-34h8v-2H75v2h2zm-3 38H8v2h84v-2H74zM63 47h-6v1h6v-1zm1 34h-8v1h8v-1zm-8-7v6h8v-6h-8zm7-28h2v-2H55v2h8zm-20 2v-1h-6v1h6zm1 34v-1h-8v1h8zm-8-2h8v-6h-8v6zm1-34h8v-2H35v2h2zm-14 1h-6v1h6v-1zm1 34h-8v1h8v-1zm-8-7v6h8v-6h-8zm7-28h2v-2H15v2h8zM4 94h92v-2H4v2zm2-4h88v-2H6v2zm-4 8h96v-2H2v2zm94-79H79.69L96 29.44V19zm0-5H71.87l6.25 4H96v-4zm-74.13 4l6.25-4H4v4h17.88zM4 29.44L20.31 19H4v10.44zM12.99 32h-1.86l1.56-1L50 7.12 87.3 31l1.57 1H12.99zM50 8.31L14.55 31h70.9L50 8.31z"
                  }
                })
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }